import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ErrorPageComponent } from './shared/pages/error-page/error-page.component';
import { authGuardActivate } from './guards/auth.guard';
import { profilesGuardActivate } from './guards/profiles-app-routing.guard';
import { profilesLogOutGuardActivate } from './guards/profiles-logout-routing.guard';
import { authPublicGuardActivate } from './guards/auth-public.guard';

const routes: Routes = [
  {
    path: '',
    canActivate:[profilesLogOutGuardActivate, authPublicGuardActivate],
    loadChildren: () => import('./site/home/modules/home.module').then( m => m.HomeModule),
  },
  {
    path: 'product-catalog',
    canActivate:[profilesLogOutGuardActivate, authPublicGuardActivate],
    loadChildren: () => import('./site/product-catalog/modules/product-catalog.module')
      .then( m => m.ProductCategoriesModule)
  },
  {
    path: 'account',
    canActivate: [ authGuardActivate, profilesLogOutGuardActivate ],
    loadChildren: () => import('./site/account/modules/account.module')
      .then( m => m.AccountModule)
  },
  {
    path: 'shopping-car',
    canActivate:[profilesLogOutGuardActivate, authPublicGuardActivate],
    loadChildren: () => import('./site/shopping-car/modules/shopping-car/shopping-car.module')
      .then( m => m.ShoppingCarModule)
  },
  {
    path: 'new-order',
    canActivate: [ authGuardActivate, profilesLogOutGuardActivate ],
    loadChildren: () => import('./site/orders/modules/orders/orders.module')
      .then( m => m.OrdersModule)
  },
  {
    path: 'coupons',
    canActivate:[profilesLogOutGuardActivate, authPublicGuardActivate],
    loadChildren: () => import('./site/coupons/modules/coupons.module').then( m => m.CouponsModule)
  },
  {
    path: 'events',
    canActivate:[profilesLogOutGuardActivate, authPublicGuardActivate],
    loadChildren: () => import('./site/events/modules/events.module').then( m => m.EventsModule)
  },
  {
    path: 'news',
    canActivate:[profilesLogOutGuardActivate, authPublicGuardActivate],
    loadChildren: () => import('./site/news/modules/news.module').then( m => m.NewsModule)
  },
  {
    path: 'termns-and-conditions',
    canActivate:[profilesLogOutGuardActivate, authPublicGuardActivate],
    loadChildren: () => import('./site/termns-and-conditions/modules/termns-and.conditions.module').then( m => m.TermnsAndConditionsModule),
  },
  {
    path: 'auth',
    canActivate:[profilesLogOutGuardActivate],
    loadChildren: () => import('./auth/modules/auth.module').then( m => m.AuthModule)
  },
  {
    path: 'platform/blogs',
    canActivate: [ authGuardActivate, profilesGuardActivate  ],
    loadChildren: () => import('./platform/blogs/modules/blogs.module').then( m => m.BlogsModule)
  },
  {
    path: 'platform/users',
    canActivate: [ authGuardActivate, profilesGuardActivate  ],
    loadChildren: () => import('./platform/users/modules/users.module').then( m => m.UsersModule),

  },
  {
    path: 'platform/sections',
    canActivate: [ authGuardActivate, profilesGuardActivate  ],
    loadChildren: () => import('./platform/sections/modules/sections.module').then( m => m.SectionsModule)
  },
  {
    path: 'platform/brands',
    pathMatch: 'full',
    loadChildren: () => import('./platform/brands/modules/brands.module').then( m => m.BrandsModule),
    canActivate: [ authGuardActivate, profilesGuardActivate  ]
  },
  {
    path: 'platform/categories',
    canActivate: [ authGuardActivate, profilesGuardActivate  ],
    loadChildren: () => import('./platform/categories/modules/categories.module').then( m => m.CategoriesModule)
  },
  {
    path: 'platform/products',
    canActivate: [ authGuardActivate, profilesGuardActivate ],
    loadChildren: () => import('./platform/products/modules/products.module').then( m => m.ProductsModule)
  },
  {
    path: 'platform/colors',
    canActivate: [ authGuardActivate, profilesGuardActivate  ],
    loadChildren: () => import('./platform/colors/modules/colors.module').then( m => m.ColorsModule)
  },
  {
    path: 'platform/areas',
    canActivate: [ authGuardActivate, profilesGuardActivate  ],
    loadChildren: () => import('./platform/areas/modules/areas.module').then( m => m.AreasModule)
  },
  {
    path: 'platform/measurement-systems',
    canActivate: [ authGuardActivate, profilesGuardActivate  ],
    loadChildren: () => import('./platform/measurement-system/modules/measurement-system.module').then( m => m.MeasurementSystemModule)
  },
  {
    path: 'platform/orders',
    canActivate: [ authGuardActivate, profilesGuardActivate  ],
    loadChildren: () => import('./platform/orders/modules/orders.module').then( m => m.OrdersModule)
  },
  {
    path: 'platform/balances',
    canActivate: [ authGuardActivate, profilesGuardActivate  ],
    loadChildren: () => import('./platform/balances/modules/balances.module').then( m => m.BalancesModule)
  },
  {
    path: 'platform/termns-and-conditions',
    canActivate: [ authGuardActivate, profilesGuardActivate  ],
    loadChildren: () => import('./platform/termns-and-conditions/modules/termns-and-conditions.module').then( m => m.TermnsAndConditionsModule)
  },
  {
    path: 'platform/providers',
    canActivate: [ authGuardActivate, profilesGuardActivate  ],
    loadChildren: () => import('./platform/providers/modules/providers.module').then( m => m.ProvidersModule)
  },
  {
    path: '404',
    component: ErrorPageComponent
  },
  {
    path: '**',
    redirectTo: '404'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {scrollPositionRestoration: 'enabled', useHash: true})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
